import { ChangeDetectorRef, Component, ComponentRef, ElementRef, ViewChild
       } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

import { QualityRating
       } from 'app/controls/image-quality-rating/quality-rating';
import { ToastComponent, ToastLevel } from 'app/controls/toast/toast.component';
import { StageConstants } from 'core/constants';
import { FittingSidePosition } from 'core/utils';
import { OverlayComponent, Region, Trigger, TriggerGroup
       } from '../overlay.component';

const ACTION = 'display_info';
const TRIGGERS: Array<Trigger> = [
  {
    icon: {
      type: 'svg',
      value: 'quality-rating',
    },
    action: ACTION,
  },
];

@Component({
  selector: 'quality-rating-icon',
  templateUrl: './quality-rating-icon.component.html',
  styleUrls: [ './quality-rating-icon.component.scss' ]
})
export class QualityRatingIconComponent extends OverlayComponent
{
  private static _AVAILABLE_SIDES: Array<FittingSidePosition> = [
    FittingSidePosition.TopLeft,
    FittingSidePosition.CenterHorizontal,
  ];
  private static _FALLBACK_SIDE: FittingSidePosition =
    FittingSidePosition.CenterHorizontal;

  public componentRef: ComponentRef<QualityRatingIconComponent>;
  public showQualityIndication: boolean = false;

  @ViewChild('triggersRef') protected triggersRef: ElementRef;
  @ViewChild('toast') private toast: ToastComponent;

  constructor(
      element: ElementRef,
      cdr: ChangeDetectorRef,
      mir: MatIconRegistry,
      sanitizer: DomSanitizer)
  {
    super(element, cdr, mir, sanitizer);
  }

  protected get AVAILABLE_SIDES(): Array<FittingSidePosition>
  {
    return QualityRatingIconComponent._AVAILABLE_SIDES;
  }

  protected get FALLBACK_SIDE(): FittingSidePosition
  {
    return QualityRatingIconComponent._FALLBACK_SIDE;
  }

  protected calculateTargetRegion(): Region
  {
    const region = super.calculateTargetRegion();

    const baseElement = ((<any>this.placeholder.wrapper)
                         .doc()
                         .node
                         .getBoundingClientRect());
    if (region.x < 0) {
      region.width += region.x;
      region.x = 0;
    }

    if (region.y < 0) {
      region.height += region.y;
      region.y = 0;
    }

    if (region.x + region.width > baseElement.width) {
      region.width = baseElement.width - region.x;
    }

    if (region.y + region.height > baseElement.height) {
      region.height = baseElement.height - region.y;
    }

    return region;
  }

  public updateQualityIndication(): void
  {
    const qualityRating = this.getQualityRating();
    if (qualityRating <= QualityRating.Q2) {
      this.showQualityIndication = true;
    }
    else {
      this.showQualityIndication = false;
    }
  }

  protected checkTriggersAreUseable(): boolean
  {
    if (this.triggerSide === this.FALLBACK_SIDE) {
      return true;
    }

    const hasClipPath = (): boolean => {
      return !!(<any>this.placeholder.wrapper).parent('[clip-path]');
    };

    return !hasClipPath();
  }

  private getQualityRating(): number
  {
    return parseInt(
        this.placeholder.get(StageConstants.ATTRIBUTE_QUALITY_RATING), 10);
  }

  public destroy(): void
  {
    this.componentRef.destroy();
  }

  protected updateTriggerGroup(): void
  {
    const positioningMethod = (() => {
      switch (this.triggerSide) {
        case FittingSidePosition.CenterHorizontal:
          return positionCenterHorizontal;
        case FittingSidePosition.TopLeft:
          return positionTopLeft;
        default:
          return positionCenterHorizontal;
      }
    })();

    this.loadIconsIfRequired(TRIGGERS);
    this.triggerGroup = positioningMethod(TRIGGERS);
  }

  public triggerClicked(action: string): void
  {
    if (action === ACTION) {
      this.toast.show(
          'i18n.dialog.insufficientImageQuality.message', ToastLevel.WARNING);
    }
  }
}

function positionCenterHorizontal(triggers: Array<Trigger>): TriggerGroup
{
  return {
    triggers: triggers,
    top: '50%',
    left: '50%',
    alignHorizontal: '-50%',
    alignVertical: '-50%',
    direction: 'row',
  };
}

function positionTopLeft(triggers: Array<Trigger>): TriggerGroup
{
  return {
    triggers: triggers,
    top: '5%',
    left: '5%',
    alignHorizontal: '0%',
    alignVertical: '0%',
    direction: 'row',
  };
}



// WEBPACK FOOTER //
// ./src/app/collage-designer/stage/placeholder/overlays/quality-rating-icon/quality-rating-icon.component.ts